/**
 * ActionList — recommended actions as a compact responsive card grid.
 */

import type { ActionListBlock } from '../../../stores/CoPilotStore'

const severityStyles = {
  info: {
    dot: 'bg-[#3B82F6]',
    bg: 'bg-[#EFF6FF]',
    border: 'border-[#BFDBFE]',
    text: 'text-[#1E40AF]',
  },
  warning: {
    dot: 'bg-[#F59E0B]',
    bg: 'bg-[#FFFBEB]',
    border: 'border-[#FDE68A]',
    text: 'text-[#92400E]',
  },
  critical: {
    dot: 'bg-[#EF4444]',
    bg: 'bg-[#FEF2F2]',
    border: 'border-[#FECACA]',
    text: 'text-[#991B1B]',
  },
}

export function ActionList({ block }: { block: ActionListBlock }) {
  return (
    <div className="space-y-2">
      {block.title && (
        <div className="text-[14px] font-semibold text-[#18181B]">{block.title}</div>
      )}
      <div className="grid gap-3 grid-cols-1 sm:grid-cols-2">
        {block.items.map((item) => {
          const style = severityStyles[item.severity] || severityStyles.info
          return (
            <div
              key={item.id}
              className={`${style.bg} border ${style.border} rounded-xl p-3 flex flex-col gap-1.5`}
            >
              <div className="flex items-center gap-2">
                <div className={`${style.dot} size-2 rounded-full shrink-0`} />
                <div className={`text-[13px] font-semibold ${style.text} leading-snug`}>
                  {item.label}
                </div>
              </div>
              <div className="text-[12px] text-[#52525B] leading-snug">
                {item.description}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
